module.exports = __webpack_public_path__ + "img/logo-green.0064eef1.png";